// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_bootstrap.js"
import "./modules/mobile-menu"

jQuery(document).ready(() => {
    //Hero Slider
    $('.hero-slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
    });

    //Resize type on Front page
    $(".resize-type__button_small").click(function () {
        $(".serving-content").children('p').css({
            "font-size": "100%",
            "line-height": "188%",
        });

        $(".entry-content").children('p').css({
            "font-size": "100%",
            "line-height": "188%",
        });

        $(".entry-content").children('ul').children('li').css({
            "font-size": "100%",
            "line-height": "188%",
        });
    });
    $(".resize-type__button_normal").click(function () {
        $(".serving-content").children('p').css({
            "font-size": "120%",
            "line-height": "140%",
        });

        $(".entry-content").children('p').css({
            "font-size": "120%",
            "line-height": "140%",
        });

        $(".entry-content").children('ul').children('li').css({
            "font-size": "120%",
            "line-height": "140%",
        });
    });
    $(".resize-type__button_big").click(function () {
        $(".serving-content").children('p').css({
            "font-size": "140%",
            "line-height": "140%",
        });

        $(".entry-content").children('p').css({
            "font-size": "140%",
            "line-height": "140%",
        });

        $(".entry-content").children('ul').children('li').css({
            "font-size": "140%",
            "line-height": "140%",
        });
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() > 40) {
            $('.header').addClass('scroll-bottom-border');

        } else {
            $('.header').removeClass('scroll-bottom-border');
        }
    });

    //Menu active parent when active child
    $('.menu-item').children('ul').children('li').children('ul').hover(
        function () {
            $(this).siblings('a').addClass('hover-2th');
        },

        function () {
            $(this).siblings('a').removeClass('hover-2th')
        }
    );

    //Sidebar image mobile position

    function widget_toggle_position() {
        let widget_image = $('.widget_media_image');

        if (widget_image) {
            if ($(window).width() < 992) {
                widget_image.insertAfter('h1');
            } else {
                widget_image.insertBefore('.widget_text');
            }
        }
    }

    // Dropdown animate
    function menuAnimate() {

        if ($(window).width() > 1200) {
            $('.navbar-nav > li.dropdown').hover(
                function () {
                    $(this).addClass('menu-hover-animation');
                },
                function () {
                    $(this).removeClass('menu-hover-animation');
                }
            );

            $('.navbar-nav > li.dropdown > ul.dropdown-menu > li.dropdown').hover(
                function () {
                    $(this).children().fadeIn();
                },
                function () {
                    $(this).find('ul').fadeOut();
                }
            );
        }

    }

    $('.navbar-toggler').click(() => {
        $('body').toggleClass('scroll-none');
    });

    // Menu Active Parent Link
    function extraUrlCondition() {

        $('.menu-item-has-children>a').on('click', function (event) {
            if ($(this).attr('href') !== '#') {
                event.preventDefault();
                window.location.href = $(this).attr('href');
            }
        });
    }

    extraUrlCondition();
    menuAnimate();
    widget_toggle_position();

    $(window).resize(function () {
        menuAnimate();
        widget_toggle_position();

        $('body').removeClass('scroll-none');
        $('.navbar-collapse ').removeClass('show');
    });
});



// WEBPACK FOOTER //
// ./scripts/main.js